module.exports = {
  BOOKED: 'booked',
  BOUGHT: 'bought',
  SOLD: 'sold',
};
